import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import CloseIcon from '@offerzen/zenicon/CloseIcon'
import AccessibleIcon from '../AccessibleIcon'
import styles, { wrapperTheme, iconTheme, wrapperSize, iconSize, iconWrapperSize, hoverTheme } from './styles'

const Tag = ({ theme, size, className, text, onClear }) => (
  <div className={cx(styles.wrapper, wrapperTheme(theme), wrapperSize(size), onClear && hoverTheme(theme), className)}>
    <span>{text}</span>

    {Boolean(onClear) && (
      <button type="button" className={cx(styles.icon, iconWrapperSize(size))} onClick={onClear}>
        <span className={styles.accessiblyHidden}>{`clear ${text}`}</span>
        <AccessibleIcon icon={CloseIcon} color={iconTheme(theme)} size={iconSize(size)} />
      </button>
    )}
  </div>
)

Tag.propTypes = {
  text: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  size: PropTypes.oneOf(['', 'default', 'small']),
  onClear: PropTypes.func,
  className: PropTypes.string,
}

Tag.defaultProps = {
  theme: 'primary',
  size: 'default',
}

export default Tag
